import React from 'react';
import officialWordmark from '../../scenes/login/eup.png';

type BrandLogoProps = {
  compact?: boolean;
  darkText?: boolean;
  partnerLabel?: boolean;
  className?: string;
};

/** Shared brand lock-up. Keep all product surfaces on this single implementation. */
export default function BrandLogo({
  compact = false,
  darkText = false,
  partnerLabel: _partnerLabel = false,
  className = '',
}: BrandLogoProps) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      aria-label="Eupago"
    >
      {compact ? (
        <img
          src="/logo-s.png"
          alt=""
          aria-hidden="true"
          className="h-9 w-9 shrink-0 object-contain"
        />
      ) : (
        <span className="relative inline-flex h-10 items-center">
          {darkText ? (
            <img
              src={officialWordmark}
              alt="Eupago"
              className="h-10 w-auto object-contain"
            />
          ) : (
            <span className="relative inline-flex h-10">
              <img
                src={officialWordmark}
                alt="Eupago"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
              <img
                src={officialWordmark}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-10 w-auto object-contain"
                style={{ clipPath: 'inset(0 82% 0 0)' }}
              />
            </span>
          )}
        </span>
      )}
    </span>
  );
}
